import { css, html, LitElement } from 'lit-element';
import '@giswebgroup/ki-wcp-base/src/components/ki-icon/ki-icon-btn';
import './ki-station-searchbox-base';
import '@giswebgroup/ki-wcp-base/src/components/ki-searchbox/ki-search-filter-action';
import LoaderMixin from '@giswebgroup/ki-wcp-base/src/common/LoaderMixin';
import query from '@giswebgroup/ki-wcp-base/src/decorators/query';
import localStorage from '@giswebgroup/ki-wcp-base/src/decorators/localStorage';
import responsive from '@giswebgroup/ki-wcp-base/src/decorators/responsive';
import i18n from '@giswebgroup/ki-wcp-base/src/decorators/i18n';
import nls from '../../locales/index.nls';

export default
@responsive
@i18n(nls)
class KiStationSearchbox extends LoaderMixin(LitElement) {
  // language=CSS
  static styles = css`
    .actions {
      position: static;
      height: 26px;
    }

    .spiner-wrapper {
      left: 22px;
    }

    paper-spinner {
      width: 20px !important;
      height: 20px !important;
      --paper-spinner-stroke-width: 1px !important;
    }

    :host(.sm-screen) .actions {
      display: none;
    }
  `;

  static get properties() {
    return {
      searchContent: { type: String },
      fieldList: { type: Array },
      __filterFields: { type: Array },
    };
  }

  @query('ki-search-filter-action')
  filterAction;

  @query('ki-station-searchbox-base')
  searchbox;

  @localStorage({ type: Array, initial: t => t.fieldList.map(f => f.field) })
  __filterFields;

  constructor() {
    super();
    this.fieldList = [];
  }

  render() {
    // language=html
    return html`
      <ki-station-searchbox-base .value="${this.searchContent || ''}" part="searchbox" @search="${this.onSearch}">
        <div slot="actions" class="actions">
          ${this._renderLoader()}
          <ki-search-filter-action id="filter-action" title="${this.i18n.t('Search_Options')}" .fieldList=${this.fieldList} .filterFields="${this.__filterFields}" @changing="${this.onSearch}"></ki-search-filter-action>
        </div>
      </ki-station-searchbox-base>
    `;
  }

  firstUpdated() {
    super.firstUpdated();
    this.onSearch();
  }

  onSearch() {
    this.searchContent = this.searchbox.value;
    const regex = new RegExp(this.searchContent, 'i');
    this.__filterFields = this.filterAction.filterFields;
    this.dispatchEvent(
      new CustomEvent('search', {
        detail: {
          searchContent: this.searchContent,
          filter: item => {
            return this.__filterFields.length > 0
              ? this.__filterFields.some(f => {
                  return regex.test(String(item[f]));
                })
              : () => true;
          },
        },
      }),
    );
  }
}

customElements.define('ki-station-searchbox', KiStationSearchbox);
